import { BaseResource } from "utils/ApiUtils";

class Organization extends BaseResource {
  constructor(args) {
    super(args, Organization.attributes);
  }

  static columns = [
    {
      title: "Organization Id",
      field: "organizationId",
      type: "guid",
      hidden: true,
      hiddenByColumnsButton: true,
      required: true
    },
    {
      title: "User Group Id",
      field: "userGroupId",
      type: "guid",
      hidden: true,
      hiddenByColumnsButton: true,
      required: true
    },
    {
      title: "State Id",
      field: "stateId",
      type: "guid",
      hidden: true,
      hiddenByColumnsButton: true,
      required: true
    },
    {
      title: "Zip",
      field: "zip",
      type: "string",
      hidden: false,
      hiddenByColumnsButton: true,
      required: true
    },
    {
      title: "Name",
      field: "name",
      type: "string",
      hidden: false,
      hiddenByColumnsButton: true,
      required: true,
      defaultSort: "asc"
    },
    {
      title: "Abbreviation",
      field: "abbreviation",
      type: "string",
      hidden: false,
      hiddenByColumnsButton: true,
      required: true
    },
    {
      title: "Address",
      field: "address",
      type: "string",
      hidden: false,
      hiddenByColumnsButton: true,
      required: true
    },
    {
      title: "City",
      field: "city",
      type: "string",
      hidden: false,
      hiddenByColumnsButton: true,
      required: true
    },
    {
      title: "State",
      field: "Description_State",
      
    },
    {
      title: "Date Entered",
      field: "dateEntered",
      type: "date",
      hidden: false,
      hiddenByColumnsButton: true,
      required: true
    },
    {
      title: "Is Active",
      field: "isActive",
      type: "boolean",
      hidden: false,
      hiddenByColumnsButton: true,
      required: true
    },
  ];

  static attributes = Organization.columns.map((r) => r.field);

  static expand = [{State: {select: ["Description"]}}];
}

export default Organization;
